import './Icon_Arrow_Wide_Down.css';

function Icon_Arrow_Wide_Down() {
  return (
    
      <div className='arrow-wide-down-icon-container'>
          <svg viewBox="0 0 24 24" className="arrow-wide-down-icon-svg">
              <path d="m3 16 4 4 4-4"/><path d="M7 20V4"/><path d="M11 4h10"/><path d="M11 8h7"/><path d="M11 12h4"/></svg>
      </div>
            
  );
}

export default Icon_Arrow_Wide_Down;

//<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-down-wide-narrow-icon lucide-arrow-down-wide-narrow"><path d="m3 16 4 4 4-4"/><path d="M7 20V4"/><path d="M11 4h10"/><path d="M11 8h7"/><path d="M11 12h4"/></svg>